export default __webpack_public_path__ + "img/667f8f92d8b7be22cd884b9b45d38bc2.png";